import { ItemListCarouselItem, ItemListCarouselItemVariant } from "@/components/item-list/types";
import { CollectionObservable } from "@/store/collections/CollectionObservable";
import { AppStore } from "@/store/AppStore";
import { trackEvent, TrackedEvent } from "@/domains/metrics";
import { MDSCollectionIcon } from "@/mds";
import { ValidSearchSortByValue } from "@/store/pages/SearchPageStore/types";

export const getItemListCarouselItemForCollection = ({
  position,
  collection,
  store,
  query,
  sortBy,
}: {
  position: number;
  collection: Pick<CollectionObservable, "id" | "label" | "overview">;
  store: AppStore;
  query: string;
  sortBy: ValidSearchSortByValue;
}): ItemListCarouselItem => ({
  id: collection.id,
  primaryLabel: collection.label,
  secondaryLabel: collection.overview ?? "",
  variant: ItemListCarouselItemVariant.Collection,
  icon: () => {
    return <MDSCollectionIcon collectionId={collection.id} size={18} />;
  },
  onClick: ({ itemId }: { itemId: string }) => {
    store.navigation.goToCollection({ collectionId: itemId });

    /**
     * Track the navigation to a collection from within a carousel
     */
    trackEvent(TrackedEvent.SearchResultsOpenCollection, {
      query: query,
      sort_by: sortBy,
      position: position,
      collection_id: collection.id,
      collection_primary_label: collection.label,
      is_in_carousel: true,
    });
  },
});
